import { MAX_ASPECT, MIN_ASPECT, GAME_H } from "../config/constants";
import { k } from "./kaplay";

export const viewport = {
    width: GAME_H * (16 / 9),
    height: GAME_H,
    uiScale: 1,
};

function update() {
    const aspect = k.width() / k.height();
    viewport.uiScale = k.height() / GAME_H;
    viewport.width = GAME_H * Math.min(Math.max(aspect, MIN_ASPECT), MAX_ASPECT);
}

update();
k.app.onResize(update);

export function visibleWorldRect() {
    const cam = k.getCamPos();
    const scale = k.getCamScale().x;
    const halfW = k.width() / 2 / scale;
    const halfH = k.height() / 2 / scale;
    return { left: cam.x - halfW, top: cam.y - halfH, right: cam.x + halfW, bottom: cam.y + halfH };
}
